export const NODE_ENV = process.env.NODE_ENV

export const IS_PRODUCTION = ["prod", "production"].includes(NODE_ENV)
